import instaclustrComponent from "./Components";
import layoutResizing from "../utils/layoutResizing";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;

        // Form label animations
        const labelAnimations = () => {
            let $form   = $('.mktoForm');
            let $inputs = $form.find('input');
            $inputs.each(function() {
                let $this = $(this);
                $this.focusin(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
                $this.focusout(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
            })
        }

        if (window.MktoForms2) {
            try {
                MktoForms2.whenReady(function() {
                    labelAnimations();
                });
            } catch (a) {
                console.log(a);
            }
        }

        // Accordion.js functionality
        // https://accordion.js.org/

        // Get all accordions
        let $accordions = jQuery('.component-free-content-two-column-2024 ul.features-accordion');

        // Initialize each accordion
        $accordions.each(function() {
            jQuery(this).accordionjs({
                activeIndex : false,
                closeAble  : true,
                closeOther : true,
                openSection: function(section) {
                    let $plus   = section.find('span.plus');
                    let $others = $('span.plus');
                    $others.each(function() {
                        $(this).html('+');
                    })
                    $plus.html('-');
                    $plus.addClass('mr-1');
                },
                closeSection: function(section) {
                    let $plus = section.find('span.plus');
                    $plus.html('+');
                    $plus.removeClass('mr-1');
                }
            });
        });

        // Video functionality
        let $columnVideos = $('.component.component-free-content-two-column-2024 .type-video');

        $columnVideos.each(function(i) {
            let $facade     = $(this).find('.video-facade .facade-container');
            let $modal      = $('#video' + i);
            let $closeModal = $modal.find('.close-modal-video');
            let $iframe     = $modal.find('iframe');

            function closeVideo(e) {
                e.preventDefault();
                $modal.fadeOut();
                // For iframes: Reset video src so video stops playing when modal is closed
                let video = $iframe.attr('src');
                $iframe.attr('src', '');
                setTimeout(function(){
                    $iframe.attr('src', video);
                }, 100);
                // For Bynder embeds:
                let $bynderVid  = $modal.find('video');
                $bynderVid[0].pause();
            }

            if ($facade) {
                $facade.on("click", function (e) {
                    e.preventDefault();
                    $modal.fadeIn();
                });
            }

            if ($closeModal) {
                $closeModal.on("click", function (e) {
                    closeVideo(e);
                });
            }

            $(document).keyup(function(e) {
                if (e.key === "Escape") { // escape key maps to keycode `27`
                    closeVideo(e);
                }
            });
        })

        // Check if the user is accessing the page on a mobile device
        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        // Adjust height of masked image column to match content
        let $component = jQuery('.component.component-free-content-two-column-2024.has-text-box');
        let $mainHeight;
        let $defaultContent    = $('.component.component-free-content-two-column-2024.has-text-box .type-default');

        if ($component.length > 0) {
            $mainHeight = $component[0].offsetHeight;
        }

        // Adjust text box and component height as needed by screen size
        let $textBox   = $('.component.component-free-content-two-column-2024.has-text-box .text-box');

        function adjustTextBox() {
            let $boxHeight = $textBox[0].offsetHeight;
            let offsetMd = ($boxHeight - 80) * -1;
            let offsetSm = ($boxHeight * .25);
            if (vpWidth > md) {
                // text box is absolute position
                $textBox.css({'bottom' : offsetMd});
            } else {
                // text box is relative position; adjust component height
                $component.css({
                    'height' : $mainHeight - (offsetSm + 80)
                });
            }
        }

        if ($textBox.length > 0) {
            adjustTextBox();
        }

        // Adjust layout after window resize
        layoutResizing();
    }
}
